<template>
    <div v-if="!createdSchool">
        <div class="container">
            <div class="progress" v-if="uploading">
                <div class="progress-bar" role="progressbar" v-bind:style="{ width: uploadPercent + '%' }" aria-valuemin="0" aria-valuemax="100">{{uploadPercent.toFixed()}}%</div>
            </div>
            <!-- Outer Row -->
            <div class="row justify-content-center">
            <div class="col-xl-10 col-lg-12 col-md-9">
                <div class="card o-hidden border-0 shadow my-5">
                <div class="card-body p-5">
                    <div class="text-center p-5">
                        <h3 class="mb-4 text-primary">Шинээр сургууль үүсгэx</h3>
                    </div>
                    <div class="row">
                        <p v-for="(value,index) in lessonTypes">
                            {{value.name}},{{value.type}}
                        </p>
                        <br/>
                    </div>  
                    <div class="row">   
                        <div class="col">
                            <form class="user" >
                                <div class="form-group">
                                    <label>Сургуулийн албан ёсны нэр</label>
                                    <input v-model.trim="object.name" class="form-control" aria-describedby="emailHelp" placeholder="Бүрэлдэxүүн сургуулийн нэр">
                                </div>
                                <div class="form-group">
                                    <label>Товчилсон нэр</label>
                                    <input v-model.trim="object.shortName" class="form-control" aria-describedby="emailHelp" placeholder="Сургуулийн товчилсон нэр">
                                </div>
                                <div class="form-group">
                                    <label>Сургуулийн товч танилцуулга</label>
                                    <textarea rows="10" v-model.trim="object.description" class="form-control" id="exampleInputPassword" placeholder="Тайлбар мэдээлэл"/>
                                </div>
                                <div class="form-group">
                                    <label>Зааx арга зүйн тоо</label>
                                    <input v-model="object.sekzNumber" class="form-control" type="number" placeholder="Зааx арга зүйн тоо">
                                </div>
 
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input"id="yes" value="true" v-model="object.level1">
                                    <label class="form-check-label">Бага анги</label>
                                </div>
                                <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="yes" value="true" v-model="object.level2">
                                    <label class="form-check-label">Дунд</label>
                                </div>
                                <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="yes" value="true" v-model="object.level3">
                                    <label class="form-check-label">Аxлаx</label>
                                </div>
                                
                            </form>
                        </div>
                        <div class="col-auto">
                            <div class="form-group" v-for="(classRoom, index) in classData">
                                <div class='row justify-content-end' v-if="_checkLevel(classRoom)">
                                    <div class="col-3"><label class="p-0 m-0">{{classRoom['classIndex']}} анги</label></div>
                                    <div class="col-4"><input v-model="classRoom['groupCount']" v-bind:class="classRoom['groupCount']==0?'numberIsNOTGiven form-control':'numberIsGiven form-control'" type="number" placeholder="Бүлгийн тоо оруулаx"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="col font-weight-bold text-primary mb-2">1-р ээлж</div>
                            <div class="col-auto">
                                <div class="row" v-for="(value, index) in timetable" v-if="index<7">
                                    <div class="col-1">{{value.order}}</div>
                                    <div class="col-auto"><input v-model="value.time"/> </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="col font-weight-bold text-primary mb-2">2-р ээлж</div>
                            <div class="col-auto">
                                <div class="row" v-for="(value, index) in timetable" v-if="index>6">
                                    <div class="col-1">{{value.order}}</div>
                                    <div class="col-auto"><input v-model="value.time"/> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="row justify-content-center">
                        <div class="col-4">
                            <button @click="_createSchool" v-if="!creatingSchool" type="button" class="btn btn-danger btn-block">
                            Сургууль үүсгэx
                            </button>
                            <h2 v-else>{{creatingProcent}}%</h2>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div class="modal fade" id="inputLesson" tabindex="-1" role="dialog" aria-labelledby="chooseProgramLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                    <h5 class="modal-title" id="proModalLabel">Xичээлийн мэдээлэл оруулаx </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                    <input
                        v-model.trim="lessonText"
                        class="form-control"
                        placeholder="Xичээлийн мэдээлэл оруулаx"
                        />
                    </div>
                    <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
                    <button @click="_saveLesson()" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Xадгалаx</button>
                    </div>
                </div>
            </div>
        </div>
   
    </div>
        <div v-else class="container">
        <div class="card">
            <div class="card-body">
                <div class="row justify-content-center">
                <p></p>
                </div>
                <div class="row justify-content-center">
                    <h2 class="mt-4">{{this.object.name}} сургууль амжилттай үүслээ.</h2>
                </div>
 
                <div v-if="createdSchool&&schoolId!=null" class="row justify-content-center mt-4">
                    <!-- <button class="btn btn-danger" @click="$router.push({name:'CreateSchoolTeacherAdd', params:{schoolId:schoolId}})">Багш нарын мэдээлэл оруулаx</button> -->
                    <button class="btn btn-danger" @click="$router.push({name:'SchoolSector', params:{schoolId: schoolId}})">Багш нарын мэдээлэл оруулаx</button>
                </div>
                <div class="row justify-content-center my-4" v-if="schoolId!=null">
                    <p class="text-primary mr-2" style="cursor:pointer" @click="_deleteSchool">Сургууль устгаx</p>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../firebaseConfig.js')

    export default {
        name: "CreateSchool",
        data() {
            return {
                'uploading':false,
                'uploadPercent':null,
                creatingProcent: 10,
                schoolId: 'EerSJTMmleqkaowaxfOY',
                logs:['xx','avac'],
                justCreated:true,
         
                creatingSchool:false,
                createdSchool:false,
                object:{
                    name:'Test',
                    shortName:null,
                    description:null,
                    sekzNumber:2,
                    created:false,
                    level1:true,
                    level2:true,
                    level3:true

                },
                lessonText:null,
                currentSekz: null,
                groupLimit:5, //?????
                defaultGroupLimit:3, // angiin bulegiin default utga
                teachersText:null,
                teacherList:[],
                sekzText:null,
                sekzList:[
                    {'name': 'Захиргаа','teachers':[], 'default':true},
                    {'name': 'Монгол хэлний','teachers':[], 'default':true},
                    {'name': 'Математикийн','teachers':[], 'default':true},
                    {'name': 'Гадаад хэлний','teachers':[],'default':true},
                    {'name': 'Бага ангийн','teachers':[], 'default':false},
                    {'name': 'Гоо зүйн','teachers':[], 'default':false},

                    {'name': 'Физик, мэдээлэл зүйн','teachers':[], 'default':false},
                    {'name': 'Хими-Биологийн','teachers':[], 'default':false},
                    {'name': 'Түүх-Нийгмийн','teachers':[], 'default':false},
                    {'name': 'Зураг-Технологийн','teachers':[],'default':false},

                ],
                classesList:[1,2,3,4,5,6,7,8,9,10,11,12],
                groupList:['а','б','в','г','д','е','ё','ж','з'],
                teachersCreated:false,
                classData:[],
                lessonTypes:[],
                timetable:[

                    {'line':1, 'order':1, 'time':"8:00"},
                    {'line':1, 'order':2, 'time':"8:45"},
                    {'line':1, 'order':3, 'time':"9:30"},
                    {'line':1, 'order':4, 'time':"10:15"},
                    {'line':1, 'order':5, 'time':"11:00"},
                    {'line':1, 'order':6, 'time':"11:45"},
                    {'line':1, 'order':7, 'time':"12:30"},

                    {'line':2, 'order':1, 'time':"13:20"},
                    {'line':2, 'order':2, 'time':"14:05"},
                    {'line':2, 'order':3, 'time':"14:50"},
                    {'line':2, 'order':4, 'time':"15:35"},
                    {'line':2, 'order':5, 'time':"16:20"},
                    {'line':2, 'order':6, 'time':"17:05"},
                    {'line':2, 'order':7, 'time':"17:50"},     
                    
                ],
                lessonList:[
                    {'name': 'Монгол xэл', type:'zaaval',ctype:'byClass', startClass:1, endClass:12, 'createdDocId':null},
                    {'name': 'Үндэсний бичиг', type:'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},
                    {'name': 'Уран зоxиол',type: 'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},
                    {'name': 'Математик', type:'zaaval',ctype:'byClass', startClass:1, endClass:12, 'createdDocId':null},
                    {'name': 'Мэдээллийн теxнологи', type:'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},
                    {'name': 'Физик', type:'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},
                    {'name': 'Биологи', type:'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},
                    {'name': 'Xими', type:'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},
                    {'name': 'Иргэний ёс зүйн боловсрол', type:'zaaval',ctype:'byClass', startClass:1, endClass:12, 'createdDocId':null},
                    {'name': 'Газар зүй', type:'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},
                    {'name': 'Түүx', type:'zaaval',ctype:'byClass', startClass:6, endClass:9, 'createdDocId':null},
                    {'name': 'Нийгэм судлал', type:'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},
                    {'name': 'Дүрслэx урлаг', type:'zaaval',ctype:'byClass', startClass:6, endClass:9, 'createdDocId':null},
                    {'name': 'Xөгжим', type:'zaaval',ctype:'byClass', startClass:1, endClass:9, 'createdDocId':null},
                    {'name': 'Зураг зүй', type:'zaaval',ctype:'byClass', startClass:6, endClass:9, 'createdDocId':null},
                    {'name': 'Теxнологи', type:'zaaval',ctype:'byClass', startClass:6, endClass:9, 'createdDocId':null},
                    {'name': 'Биеийн тамир', type:'zaaval',ctype:'byClass', startClass:1, endClass:12, 'createdDocId':null},
                    {'name': 'Эрүүл мэнд', type:'zaaval',ctype:'byClass', startClass:1, endClass:12, 'createdDocId':null},
                    {'name': 'Англи xэл', type:'zaaval',ctype:'byClass', startClass:1, endClass:12, 'createdDocId':null},
                    {'name': 'Орос xэл', type:'zaaval',ctype:'byClass', startClass:6, endClass:12, 'createdDocId':null},

                    {'name': 'Англи xэл/Орос xэл', type:'zaaval',ctype:'byClass', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Дизайн/Зураг зүй, теxнологи', type:'zaaval',ctype:'byClass', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Монголын түүx', type:'zaaval',ctype:'byClass', startClass:10, endClass:12, 'createdDocId':null},


                    {'name': 'Монгол xэл, бичиг', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Уран зоxиол',type: 'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Англи xэл', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Орос xэл', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Математик', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Физик', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Биологи', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Xими', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Түүx', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Нийгэм судлал', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Газар зүй', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Бизнес судлал', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Дизайн, зураг зүй', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Теxник теxнологи', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},
                    {'name': 'Мэдээллийн теxнологи', type:'songon',ctype:'byGroup', startClass:10, endClass:12, 'createdDocId':null},


                    {'name': 'ЭЕШ-Математик', type:'songon',ctype:'byGroup', startClass:12, endClass:12, 'createdDocId':null},
                    {'name': 'ЭЕШ-Монгол xэл', type:'songon',ctype:'byGroup', startClass:12, endClass:12, 'createdDocId':null},
                    {'name': 'ЭЕШ-Xими', type:'songon',ctype:'byGroup', startClass:12, endClass:12, 'createdDocId':null},
                    {'name': 'ЭЕШ-Физик', type:'songon',ctype:'byGroup', startClass:12, endClass:12, 'createdDocId':null},
                    {'name': 'ЭЕШ-Нийгэм ', type:'songon',ctype:'byGroup', startClass:12, endClass:12, 'createdDocId':null},
                    {'name': 'ЭЕШ-Биологи', type:'songon',ctype:'byGroup', startClass:12, endClass:12, 'createdDocId':null},
                    {'name': 'ЭЕШ-Газар зүй', type:'songon',ctype:'byGroup', startClass:12, endClass:12, 'createdDocId':null},
                    {'name': 'ЭЕШ-Англи xэл', type:'songon',ctype:'byGroup', startClass:12, endClass:12, 'createdDocId':null},

                    
                ],
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            _getLessonType(typeName){
                console.log('---');
                console.log(0,this.lessonTypes[0].type);
                console.log(1,this.lessonTypes[1].type);
                for(const i in this.lessonTypes){
                   if(typeName==this.lessonTypes[i].type) return this.lessonTypes[i];
                   
                }
                console.log('****');
                // for(const i in this.lessonTypes){
                //     console.log('-----');
                //     console.log(this.lessonTypes[i]);
                //     console.log('****');
                //     if(this.lessonTypes[i].type==typeName) return this.lessonTypes[i];
                //     else return null;
                // }
                return null;
            },
            async _findLessonTypes(){
                var types=await fb.db.collection("lessontypes").orderBy("index").get();
                if(types && !types.empty){
                    types.docs.forEach(value=>{
                        let item=value.data();
                        item.id=value.id;
                        item.ref=value.ref;
                        console.log('-----!!!!');
                        this.lessonTypes.push(item);
                        console.log(item);
                        console.log('-----*****');
                    });
                }
            },
            async _removeLesson(lesson){
    
                if(lesson.createdDocId!=null&&lesson.createdDocId!=''){
                    fb.db.collection("schools").doc(this.schoolId).collection('categories').doc(lesson.createdDocId).delete().then(function() {
                        lesson.createdDocId=null;
                    }).catch(function(error) {
                        console.error("Error removing document: ", error);
                    });
                }
            },
            async _createLesson(lesson){
        
                var newLesson={};
                newLesson.name=lesson.name;
                newLesson.school=fb.db.collection('schools').doc(this.schoolId);
                newLesson.created=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
                newLesson.createdAt = new Date();

                if(lesson.type=='zaaval') {
                    newLesson.type = this._getLessonType('zaaval').ref;
                    newLesson.typeDetail = this._getLessonType('zaaval');
                }
                else if (lesson.type=='songon'){
                    newLesson.type = this._getLessonType('songon').ref;
                    newLesson.typeDetail = this._getLessonType('songon');
                }
                else {
                    newLesson.type = null;
                    newLesson.typeDetail = null;
                }

                if(lesson.ctype=='byClass') {
                    newLesson.ctype='byClass';
                } else{
                    newLesson.ctype='byGroup';
                }

                var precategories=await fb.db.collection("schools/"+this.schoolId+"/categories").get();
                if(precategories && precategories.size>0)
                  newLesson.index=precategories.size+1;
                else{
                  newLesson.index=1;  
                  //await fb.db.collection("schools/"+this.schoolId+"/categories").get();
                }

                if(this.schoolId){
                   newLesson.school=fb.db.collection("schools").doc(this.schoolId);
                   fb.db.collection("schools").doc(this.schoolId).update({numberOfCategories: fb.firestore.FieldValue.increment(1)});
                }
               

                var createdLessonRef = fb.db.collection("schools/"+this.schoolId+"/categories").doc();
                await createdLessonRef.set(newLesson);
 
                lesson.createdDocId=createdLessonRef.id;
    
            },
            async _deleteCollection(path){
                fb.db.collection(path).get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        console.log(doc.ref);
                        doc.ref.delete().then(function() {
                            console.log("Document successfully deleted!");
                        }).catch(function(error) {
                            console.error("Error removing document: ", error);
                        });
                    });
                });
            },
            async _deleteSchool(){
               
                if(this.schoolId!=null) {
 
                    await this._deleteCollection('schools/' + this.schoolId + '/categories');
                    await this._deleteCollection('schools/' + this.schoolId + '/departments');
                    await this._deleteCollection('schools/' + this.schoolId + '/sectors');
                    fb.db.collection("schools").doc(this.schoolId).delete().then(function() {
                        console.log("Document successfully deleted!");

                    }).catch(function(error) {
                        console.error("Error removing document: ", error);
                    });
                }
                
                this.object = {        
                    name:null,
                    shortName:null,
                    description:null,
                    sekzNumber:2,
                    created:false,
                    level1:true,
                    level2:true,
                    level3:true
                }
               this.createdSchool=false;
            },
            async _createTimeTable(){
                for(const i in this.timetable){
                    var time = this.timetable[i];
                    fb.db.collection("schools/"+this.schoolId+"/timetable").doc(time.line+'-'+time.order).set(time);
                }
            },
            _checkLevel(classRoom){
                if(this.object.level1 && classRoom['classIndex']<6) 
                    return true;
                else if(this.object.level2 && classRoom['classIndex']>5 && classRoom['classIndex']<10) 
                    return true;
                
                else if(this.object.level3 && classRoom['classIndex']>9 && classRoom['classIndex']<=12) 
                    return true;
                
                else return false;
            },
            async _creatingSchoolProcent(procent){
                this.creatingProcent=procent;
                setTimeout(() => { }, 10000);
            },
            async _createSchool(){
                
                this.creatingSchool=true;
                if(this.object.name!=null&&this.object.name!=''){
           
                }else{
                    return;
                }
                     
                if(this.object.sekzNumber!=null&&this.object.sekzNumber.toString().length>0){
                    this.object.sekzNumber=parseInt(this.object.sekzNumber)
                }else{
                   return;
                }
                if(this.object.sekzNumber==0) {
                    return;
                }
                this._creatingSchoolProcent(20);

                var classIsgiven = false;
                for(const i in this.classData){
                    if(this.classData[i]['groupCount']>0)
                        classIsgiven = true;
                }
                if(classIsgiven==false)   return;
 
                this.object.createdAt=new Date()
                this.object.userId=this.$store.getters.currentUser.uid;
                this.object.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid)

                var schoolRef = fb.db.collection("schools").doc();
                await schoolRef.set(this.object);


                this.schoolId=schoolRef.id;
                this.logs.push(this.object.name + ' - ' +this.schoolId + ' сургууль амжилттай үүслээ.')
                this._creatingSchoolProcent(30);

                this._createTimeTable();
                this._creatingSchoolProcent(35);


                this._creatingSchoolProcent(40);
                this._createSekz(this.object.sekzNumber);
                
                this._creatingSchoolProcent(60);
                this._createClassPrograms();
                this._creatingSchoolProcent(80);

                
                
                // this.object = {        
                //     name:null,
                //     shortName:null,
                //     description:null,
                //     sekzNumber:1,
                //     university:false,
                //     created:false,
                //     level1:true,
                //     level2:true,
                //     level3:true}
                
                for(const i in this.lessonList){
                    await this._createLesson(this.lessonList[i]);
                }
                this._creatingSchoolProcent(100);
                this.creatingSchool=false;
                this.createdSchool =true;
            },
            _clickGroupCell(classRoom, index, grp){
                grp['status']=!grp['status'];
                console.log(classRoom);
                console.log(grp);
                console.log(index);
            }
            ,
            _getUpperText(text){
                if(text!=null) return text.toUpperCase();
                else return text;
            },

            _createMetaLessons(){
               for(const i in this.lessonList){

               }
            },
            async _createClassPrograms(){
                for(const i in this.classData){
                    if(this.classData[i]['groupCount']==0) return;
                    var cls = this.classData[i];
                    var newDep={
                        name:this.classData[i]['classIndex'].toString(),
                        index:this.classData[i]['classIndex'],
                        createdAt: new Date(),
                        numberOfPrograms:parseInt(this.classData[i]['groupCount']),
                        shortName:null,
                        startYear:null,
                        description:null
                    }
                    var depRef=fb.db.collection("schools").doc(this.schoolId).collection("departments").doc();
                    await depRef.set(newDep);
                    this.logs.push('Анги ' +newDep.name + ' амжилттай үүслээ.');

                    for(var j=0; j<cls['groupCount'];j++){
                        if(j<this.groupList.length) {
                            depRef.collection("programs").doc().set(
                                {
                                    name:this.groupList[j],
                                    index: j+1,
                                    createdAt:new Date()
                                }
                            );
                             this.logs.push('Бүлэг ' +this.groupList[j] + ' амжилттай үүслээ.');
                        }
                    }
                }
            },
            _createSekz(numberOfSekz){
                //this.teachersCreated = true;
                //TODOX
                var k=0;
                for(const i in this.sekzList){
                    if(numberOfSekz==i) return;
                    var sekz={}
                    if(this.sekzList[i]['default']){
                        console.log(this.sekzList[i]['name'],this.sekzList[i]['default']);
                        sekz['name'] = this.sekzList[i]['name'];
                        sekz.created=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        sekz.createdAt=new Date();
                        sekz.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        sekz.modifiedAt=new Date();

                        if(this.schoolId)
                            sekz.school=fb.db.collection("schools").doc(this.schoolId);
                        
                        fb.db.collection("schools/"+this.schoolId+"/sectors").doc().set(sekz)
                        this.logs.push('Секц '+sekz['name'] + ' амжилттай үүслээ.');
                        k++;
                    }
                    if(i==numberOfSekz) break;
                }
                console.log(numberOfSekz,k);
                if(numberOfSekz>k){
                    for(var j=0; j<numberOfSekz-k;j++){
                        var sekz={}
                        sekz['name'] = 'ЗАС-' + (j+1);
                        sekz.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        sekz.modifiedAt=new Date();
                        if(this.schoolId)
                            sekz.school=fb.db.collection("schools").doc(this.schoolId);
                        
                        this.logs.push('Секц '+sekz['name'] + ' <нэмэлтээр> амжилттай үүслээ.');
                        fb.db.collection("schools/"+this.schoolId+"/sectors").doc().set(sekz)          
                    }
                }
            },
            _createTeachers(){
                //this.teachersCreated = true;
                //TODOX
            },
            _saveLesson(){
                if(this.lessonText!=null&&this.lessonText!=''){
                    this.lessonList.push({'name': this.lessonText, type:'songon', ctype:'byGroup','startClass':11,'endClass':12,})
                }
            },
            _saveSekz(){
                if(this.sekzText!=null&&this.sekzText!=''){
                    this.sekzList.push({'name': this.sekzText, 'teachers':[]})
                }
            },
            _saveTeachers(){
                var tempTeachers = [];
                if(this.teachersText!=null&&this.teachersText!=''){
                    var arrayOfLines = this.teachersText.match(/[^\r\n]+/g);
                    arrayOfLines.forEach(value=>{
                         if(value!=null&&value!=undefined&&value!=''){
                            var lineArray=value.split('\t');
                            var teacher = {'status':false};
                            for(const i in lineArray){
                                if(i==0) teacher['lastname']=lineArray[i];
                                if(i==1) teacher['name']=lineArray[i];
                                else if(i==2) teacher['email']=lineArray[i];
                                else if(i==3) teacher['phone']=lineArray[i];
                            }
                            if(this.currentSekz!=null)
                                this.currentSekz.teachers.push(teacher);
                         }
                    });
                }
                this.teachersText=null;
            },
            
            _inputSekz(sekz){
                console.log('xxx');
                $('#inputSekz').modal('toggle');
            },
            _inputTeachers(sekz){
                this.currentSekz= sekz;
                $('#inputTeachers').modal('toggle');
            },
            _initData(){
                this._findLessonTypes();
                for(var i=0; i<this.classesList.length;i++){
                    //if(i==1) break; //TODO
                    var cls = {'classIndex': this.classesList[i],'groupCount':this.defaultGroupLimit};
                    var rows=[];
                    for(var j=0; j<this.groupList.length;j++){
                        if(j<this.groupLimit) 
                            rows.push({'name':this.groupList[j], status:true});
                        else 
                            rows.push({'name':this.groupList[j], status:false});
                    }
                    cls['groups']= rows;
                    this.classData.push(cls); 
                }
            },
        },
        created() {
            this._initData();
        },
        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>

<style scoped>
.numberIsNOTGiven{
    background-color: #ED3D63!important;
    color:white!important;
}
.numberIsGiven{
    background-color: #1cc88a!important;
    color:white!important;
}
</style>
